import { FC } from 'react'

import { nanoid } from 'nanoid'

import { BlockCardPopular } from 'shared/ui/block-card-popular'

import { PopularRoutesSkeleton } from './components'
import { Props } from './model'
import s from './styles.module.scss'

export const PopularDirectionsUi: FC<Props> = ({ populars, goPagePopular }) => {
  return (
    <>
      {!populars?.length
        ? Array(8)
            .fill(1)
            .map(() => (
              <div
                className={s.swiperCard}
                key={nanoid()}
              >
                <PopularRoutesSkeleton />
              </div>
            ))
        : populars?.map((item, index) => (
            <div
              key={nanoid()}
              className={s.swiperCard}
              onClick={() => goPagePopular?.(index)}
            >
              <BlockCardPopular {...item} />
            </div>
          ))}
    </>
  )
}
